import React from 'react';
import './style.scss';
import CardsServices from 'src/views/SoftwareEngineering/components/CardsServices';
import { cardDataNLP } from 'src/shared/utils/string';
import FooterServices from 'src/views/SoftwareEngineering/components/FooterServices';
import Footer from 'src/components/footer';
import BreadcrumbAiMl from '../Breadcrumb';
import { Link } from 'react-router-dom';

const NaturalLanguageProcessing = () => {
  return (
    <div className="page-container-nlp">
        <div className='image-container'>
          <div className='text-container drop-in-2'>
          <h1 className='heading drop-in'>Natural Language Processing (NLP)</h1>
          </div>
            <Link to="/natural-language-processing" className='no-decoration '><BreadcrumbAiMl text={'Natural Language Processing (NLP)'} /></Link>
            <div className='red-bg-box'></div>
        </div>

        <CardsServices cardDataServices={cardDataNLP} />
        <FooterServices />
        <Footer />
    </div>
  )
}

export default NaturalLanguageProcessing